var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ zoom: _vm.zoomRatio })},[_c('div',{style:({ width: _vm.w + 'px', height: _vm.h + 'px'}),attrs:{"id":`pumpDailyGraph_bar_${_vm.id}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }